import { Link } from 'react-router-dom';

export default function Advantages() {
  const advantages = [
    {
      icon: 'ri-smartphone-line',
      title: '下拉式阅读',
      desc: '专为移动端优化的竖向滚动阅读模式，无需翻页，一滑到底，看漫画像刷短视频一样流畅舒适。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '更新及时',
      desc: '同步韩国最新连载进度，热门作品每日更新，绝不错过任何一话精彩内容，追更体验一流。',
    },
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      desc: '全部作品提供高清画质，细节清晰可见，完美还原韩漫细腻画风，带来沉浸式视觉享受。',
    },
    {
      icon: 'ri-global-line',
      title: '资源丰富',
      desc: '收录数千部韩国漫画，涵盖恋爱、奇幻、动作、悬疑等多种类型，总有一部合你口味。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5 relative">
            <span className="inline-block px-3 py-1.5 rounded-full text-xs font-medium border border-primary-300 text-primary-600 mb-4">
              为什么选择我们
            </span>
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20reading%20on%20phone%20illustration%2C%20cozy%20reading%20atmosphere%2C%20warm%20lighting%2C%20digital%20comic%20reading%2C%20scroll%20view%20concept%2C%20soft%20peach%20and%20cream%20background%2C%20modern%20minimal%20style%2C%20comfortable%20vibe%2C%20illustrative%20art%2C%20casual%20scene&width=900&height=1200&seq=advantage-illustration&orientation=portrait"
                alt="韩漫画下拉式阅读体验"
                title="韩漫画免费阅读 - 下拉式阅读体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              为韩漫爱好者打造的
              <br />
              最佳阅读平台
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
              我们深知韩漫迷对阅读体验的追求，从页面交互到内容更新，
              每一个细节都精心打磨，只为给你最好的追漫体验。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {advantages.map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors duration-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                    <i className={`${item.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}